export enum Routes {
  Main = '/',
  Login = '/login',
  Profile = '/profile',
  Projects = '/projects',
  Config = '/config',
  Users = '/users',
  Groups = '/groups',
  Permissions = '/groups/:groupId/permissions',
  Templates = '/templates',
  TemplateFields = '/templates/:templateId/fields',
  BusinessTypes = '/templates/business-types',
  Fields = '/templates/fields',
  PromoGroups = '/promo-groups',
  PromoPeriods = '/promo-periods',
  PromoHierarchyLevels = '/promo-hierarchy-levels',
  PromoTargetVariables = '/promo-target-variables',
  PromoConstraints = '/promo-constraints',
  PromoLogs = '/promo-logs',
  RtmGroups = '/rtm-groups',
  RtmParameters = '/rtm-params',
  TetrisGroups = '/tetris-groups',
  TetrisDefaultPrices = '/tetris-default-prices',
  TetrisLogs = '/tetris-logs',
  CfrGroups = '/cfr-groups',
  CfrPfrParams = '/cfr-pfr-params',
  CfrLogs = '/cfr-logs',
  PrgmManuals = '/prgm-manuals',
  PrgmValidation = '/prgm-validation',
}
